<template>
  <v-card
    flat
  >
  <!-- Purchase Toolbar -->
  <v-toolbar
    v-if="!success"
    dark
    color="error"
  >
    <v-btn
      icon
      dark
      @click="clearAndClose()"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-toolbar-title>Purchase Shares (Administrator)</v-toolbar-title>
  </v-toolbar>
  <!-- Successful purchase toolbar -->
  <v-toolbar
    v-else
    dark
    color="green"
  >
    <v-btn
      icon
      dark
      @click="clearAndClose()"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-toolbar-title>Congratulations!</v-toolbar-title>
  </v-toolbar>

  <v-card-title v-if="!success">{{ flipAsset.title }}</v-card-title>
  <v-card-title v-else>You've successfully purchased {{ shares }} shares of <br> {{ flipAsset.title }}</v-card-title>
  <v-card-subtitle class="mt-1 pb-3"><strong>{{ flipAsset.sharesForSale }}</strong> available shares of <strong>{{ flipAsset.title }}</strong>.</v-card-subtitle>

    <v-divider class="mx-3"></v-divider>

    <v-card-text v-if="!success">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-row>
          <v-col cols="8" class="pa-0">
            <v-subheader class="mt-2">Number of Shares to Purchase</v-subheader>
          </v-col>
          <v-col cols="4" class="py-0 px-3">
            <v-text-field
              label="Shares"
              v-model="shares"
              :hint="flipAsset.sharesForSale + ' available'"
              :rules="[rules.number]"
              @input="checkAbility"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="8" class="pa-0">
            <v-subheader>Price Per Share</v-subheader>
          </v-col>
          <v-col cols="4" class="pa-0">
            <v-subheader>{{ flipAsset.pricePerShare | numberToMoney }}</v-subheader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="8" class="pa-0">
            <v-subheader>Total Cost</v-subheader>
          </v-col>
          <v-col cols="4" class="pa-0">
            <v-subheader>{{ flipAsset.pricePerShare * shares | numberToMoney }}</v-subheader>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider class="mx-3" v-if="!success"></v-divider>

    <v-card-actions class="pa-0 ma-0" v-if="!success">
      <v-card-subtitle
        v-if="error"
        class="red--text"
      >
      </v-card-subtitle>
      <v-card-subtitle v-else >
        You are placing an order to buy <strong>{{ shares }}</strong> shares of <strong>{{ flipAsset.title }}</strong> for <strong>{{ flipAsset.pricePerShare * shares | numberToMoney }}</strong>.
      </v-card-subtitle>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="!canPurchase || !shares"
        @click="buyShares"
        class="mr-3"
      >
        Purchase
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'PurchaseShareForm',

    computed: {
      ...mapGetters([
        'user',
        'flipAsset',
        'purchaseAbility'
      ])
    },

    data: () => ({
      error: false,
      shares: '',
      canPurchase: false,
      integrationId: '',

      // Form handling
      loading: false,
      valid: true,
      success: false,

      // validation rules
      rules: {
        number: value => {
          return !!value && Number.isInteger(Number(value)) || 'Must be a whole number.'
        }
      }
    }),

    methods: {
      ...mapActions([
        'adminPurchaseShares',
        'getFlipAssetById'
      ]),

      checkAbility: function() {
        // Sanity check before we start hitting the API.
        if (this.rules.number(this.shares) === true || !this.shares) {
          if (!!this.shares && this.shares > 0 && this.shares <= this.flipAsset.sharesForSale) {
            this.canPurchase = true
          }
          else {
            this.canPurchase = false
          }
        }
      },

      buyShares: function() {
        this.loading = true

        // Check validation
        this.$refs.form.validate()

        if (this.valid == true) {
          console.log(`attempting admin purchase of ${this.shares} shares`)
          console.log(`for asset ${this.flipAsset.id}`)

          // Purchase shares.
          this.adminPurchaseShares({
            assetId: this.flipAsset.id,
            numShares: this.shares
          }).then(async () => {
            // Sucess! Close everything out.
            console.log(`Successfully purchased ${this.shares} shares for asset ${this.flipAsset.id}.`)
            this.loading = false
            this.success = true
            //this.$refs.form.reset()
            //this.$emit('dialog-close')
          }).catch(err => {
            console.error(err)
            this.success = false
            this.loading = false
          })
        }
        else {
          this.loading = false
        }
      },

      clearAndClose: function() {
        this.success = false
        this.$emit('dialog-close')
      }
    },

    mounted() {
      this.success = false
      this.$refs.form.reset()
      this.checkAbility()
    }
  }
</script>
